import React from "react";

function KPI2Svg({ color = "#000000", width = 24, height = 24 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={width}
      height={height}
      x="0"
      y="0"
      viewBox="0 0 512 512"
      fill={color}
    >
      <g>
        <path
          d="M76 452h60c8.29 0 15-6.71 15-15V316c0-8.29-6.71-15-15-15H76c-8.29 0-15 6.71-15 15v121c0 8.29 6.71 15 15 15zM256 452c8.29 0 15-6.71 15-15V226c0-8.29-6.71-15-15-15h-60c-8.29 0-15 6.71-15 15v211c0 8.29 6.71 15 15 15zM497 211h-60c-8.29 0-15 6.71-15 15v211c0 8.29 6.71 15 15 15h60c8.29 0 15-6.71 15-15V226c0-8.29-6.71-15-15-15zM376 452c8.29 0 15-6.71 15-15V286c0-8.29-6.71-15-15-15h-60c-8.29 0-15 6.71-15 15v151c0 8.29 6.71 15 15 15zm0 0"
          fill={color}
          opacity="1"
          data-original={color}
        ></path>
        <path
          d="M497 31h-60c-8.29 0-15 6.71-15 15s6.71 15 15 15h23.79l-95.513 94.512C359.41 152.703 352.926 151 346 151c-12.102 0-23.055 4.855-31.148 12.652l-44.403-22.199c.223-1.808.551-3.586.551-5.453 0-24.813-20.188-45-45-45s-45 20.188-45 45c0 4.672.918 9.09 2.246 13.328L130.91 188.57c-7.14-4.77-15.7-7.57-24.91-7.57-24.813 0-45 20.188-45 45s20.187 45 45 45 45-20.188 45-45c0-4.672-.918-9.09-2.246-13.328l52.336-39.242c7.14 4.77 15.7 7.57 24.91 7.57 12.102 0 23.055-4.855 31.148-12.652l44.403 22.199c-.223 1.808-.551 3.586-.551 5.453 0 24.813 20.187 45 45 45s45-20.188 45-45c0-6.926-1.703-13.41-4.512-19.277L482 82.21V106c0 8.29 6.71 15 15 15s15-6.71 15-15V46c0-8.29-6.71-15-15-15zm0 0"
          fill={color}
          opacity="1"
          data-original={color}
        ></path>
        <path
          d="M497 482H30V15c0-8.29-6.71-15-15-15S0 6.71 0 15v482c0 8.29 6.71 15 15 15h482c8.29 0 15-6.71 15-15s-6.71-15-15-15zm0 0"
          fill={color}
          opacity="1"
          data-original={color}
        ></path>
      </g>
    </svg>
  );
}

export default KPI2Svg;
